import { render, staticRenderFns } from "./SelecaoEmpresa.vue?vue&type=template&id=70ed2481&scoped=true"
import script from "./SelecaoEmpresa.vue?vue&type=script&lang=js"
export * from "./SelecaoEmpresa.vue?vue&type=script&lang=js"
import style0 from "./SelecaoEmpresa.vue?vue&type=style&index=0&id=70ed2481&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.33_cache-loader@4.1.0_webpack@4.47.0__css-load_2ea687c826b7d973d8594d3aaaaddc42/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ed2481",
  null
  
)

export default component.exports